import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const ACTION_LABEL = {
  create: "Krijoi", update: "Përditësoi", delete: "Fshiu", login: "Hyrje",
};
const ACTION_COLOR = {
  create: "bg-[#4A8B71]/15 text-[#2C4C3B]",
  update: "bg-[#EAE4D9] text-[#2C4C3B]",
  delete: "bg-[#9E3C3C]/15 text-[#9E3C3C]",
  login: "bg-[#2C4C3B] text-[#FDFBF7]",
};
const ENTITY_LABEL = {
  patient: "Pacient", appointment: "Takim", invoice: "Faturë",
  user: "Përdorues", auth: "Auth",
};
const ROLE_LABEL = {
  admin: "Administrator", doctor: "Mjek", receptionist: "Recepsionist",
  assistant: "Asistent", public: "Portal Publik", "—": "—",
};

const fmt = (iso) => {
  try { return new Date(iso).toLocaleString("sq-AL", { dateStyle: "medium", timeStyle: "short" }); }
  catch { return iso; }
};

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState({ entity_type: "", action: "" });

  const load = async () => {
    const params = { limit: 200 };
    if (filter.entity_type) params.entity_type = filter.entity_type;
    if (filter.action) params.action = filter.action;
    const { data } = await api.get("/audit", { params });
    setRows(data);
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [filter]);

  return (
    <div className="space-y-8" data-testid="audit-page">
      <div>
        <div className="label-eyebrow">Siguria & Auditimi</div>
        <h1 className="mt-2 text-4xl font-semibold tracking-tight sm:text-5xl">Audit Log</h1>
        <p className="mt-2 text-sm text-[#5C5C5C]">Regjistër i të gjitha veprimeve të kryera në sistem (200 të fundit).</p>
      </div>

      <div className="flex flex-wrap gap-2">
        <FilterChip label="Të gjitha" active={!filter.entity_type && !filter.action} onClick={() => setFilter({ entity_type: "", action: "" })} />
        <FilterChip label="Pacientë" active={filter.entity_type === "patient"} onClick={() => setFilter({ ...filter, entity_type: "patient" })} />
        <FilterChip label="Takime" active={filter.entity_type === "appointment"} onClick={() => setFilter({ ...filter, entity_type: "appointment" })} />
        <FilterChip label="Fatura" active={filter.entity_type === "invoice"} onClick={() => setFilter({ ...filter, entity_type: "invoice" })} />
        <FilterChip label="Përdorues" active={filter.entity_type === "user"} onClick={() => setFilter({ ...filter, entity_type: "user" })} />
        <FilterChip label="Hyrje" active={filter.action === "login"} onClick={() => setFilter({ entity_type: "", action: "login" })} />
      </div>

      <div className="surface-card overflow-hidden">
        {rows.length === 0 ? (
          <div className="p-10 text-center text-sm text-[#5C5C5C]">Pa regjistrime ende.</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-[#FDFBF7] text-left">
              <tr>
                <th className="px-6 py-3 label-eyebrow">Koha</th>
                <th className="px-6 py-3 label-eyebrow">Përdoruesi</th>
                <th className="px-6 py-3 label-eyebrow">Veprimi</th>
                <th className="px-6 py-3 label-eyebrow">Entiteti</th>
                <th className="px-6 py-3 label-eyebrow">Përshkrimi</th>
                <th className="px-6 py-3 label-eyebrow">IP</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-[#E2DFD8]" data-testid={`audit-row-${r.id}`}>
                  <td className="px-6 py-3 text-xs text-[#5C5C5C] whitespace-nowrap">{fmt(r.created_at)}</td>
                  <td className="px-6 py-3">
                    <div className="font-medium">{r.user_name}</div>
                    <div className="text-xs text-[#5C5C5C]">{ROLE_LABEL[r.user_role] || r.user_role}</div>
                  </td>
                  <td className="px-6 py-3">
                    <span className={`rounded-full px-3 py-1 text-xs font-medium ${ACTION_COLOR[r.action] || "bg-gray-100"}`}>
                      {ACTION_LABEL[r.action] || r.action}
                    </span>
                  </td>
                  <td className="px-6 py-3 text-sm">{ENTITY_LABEL[r.entity_type] || r.entity_type}</td>
                  <td className="px-6 py-3 text-sm">{r.summary}</td>
                  <td className="px-6 py-3 text-xs font-mono text-[#5C5C5C]">{r.ip || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function FilterChip({ label, active, onClick }) {
  return (
    <button onClick={onClick}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              active ? "bg-[#2C4C3B] text-[#FDFBF7]" : "bg-white border border-[#E2DFD8] text-[#5C5C5C] hover:text-[#2C4C3B]"
            }`}>
      {label}
    </button>
  );
}
